
<div class="addCoin animate__animated animate__fadeIn">
  <h1>Add your coin</h1>
  <form id="addCoinForm" #form="ngForm" role="form" novalidate autocomplete="off">
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <label>Coin*</label>
          <div class="inputBox">
            <input maxlength="60" class="form-control" placeholder="Bitcoin" [(ngModel)]="coin.name" #coinName="ngModel" name="coinName" type="text" [ngClass]="{ 'is-invalid': submitted && coinName.errors && coinName.errors.required }" required>
          </div>
          <p *ngIf="coinName.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinName.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label>Symbol*</label>
          <div class="inputBox">
            <input maxlength="30" class="form-control" placeholder="BTC" [(ngModel)]="coin.symbol" #coinSymbol="ngModel" name="coinSymbol" type="text" [ngClass]="{ 'is-invalid': submitted && coinSymbol.errors && coinSymbol.errors.required }" required>
          </div>
          <p *ngIf="coinSymbol.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinSymbol.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group">
          <label>Network*</label>
          <div  class="inputBox">
            <ng-select [items]="networks"
                       bindLabel="name"
                       bindValue="value"
                       [(ngModel)]="coin.network"
                       #coinNetwork="ngModel" name="coinNetwork"
                       placeholder="{{ 'selectNetwork' | translate }}"
                       class="custom"
                       [ngClass]="{ 'is-invalid': submitted && coinNetwork.errors && coinNetwork.errors.required }" required>
            </ng-select>
          </div>

          <p *ngIf="coinNetwork.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinNetwork.errors.required">
              {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <div class="form-group">
            <label>Image</label>
            <input style="display: none" id="uploadSingle" type="file" (change)="fileDropPdf($event, false);" accept="image/*">
            <div class="imageToShow" *ngIf="coin.logo">
              <img [src]="coin.logo" />
              <span (click)="deleteImage()">Remove image</span>
            </div>
            <div *ngIf="!coin.logo" (click)="openFilepload()" id="dragAndDrop" class="uploadImage" [ngClass]="{'is-invalid': submitted && imageURL.errors && imageURL.errors.required, 'hasFile': coin.logo}" (drop)="fileDropPdf($event, true)" (dragover)="fileDropOverPdf($event)" (dragleave)="mouseDragLeavePdf($event)" (dragenter)="mouseDragEnterPdf($event)">
              <p>{{ 'dragAndDrop' | translate }}</p>
            </div>
            <input type="hidden" [(ngModel)]="coin.logo" #imageURL="ngModel" name="imageURL" required>
            <p *ngIf="imageURL.errors && submitted" class="formError">
              <span *ngIf="imageURL.errors.required">
                {{ 'fieldRequired' | translate }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
<!--        <div style="display:none" class="form-group">-->
<!--          <label>Image*</label>-->
<!--          <div class="inputBox">-->
<!--            <input maxlength="250" [pattern]="'(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'" class="form-control" placeholder="https//coincatapult.com/logo.png" [(ngModel)]="coin.image" #coinImage="ngModel" name="coinImage" type="text" [ngClass]="{ 'is-invalid': submitted && coinImage.errors && (coinImage.errors.required || coinImage.errors.pattern) }" required>-->
<!--          </div>-->
<!--          <p *ngIf="coinImage.errors && submitted" class="formError animate__animated ">-->
<!--            <span *ngIf="coinImage.errors.required">-->
<!--               {{ 'fieldRequired' | translate }}-->
<!--            </span>-->
<!--            <span *ngIf="coinImage.errors.pattern">-->
<!--               {{ 'invalidWebsite' | translate }}-->
<!--            </span>-->
<!--          </p>-->
<!--        </div>-->
        <div class="form-group">
          <label>Contract address*</label>
          <div class="inputBox">
            <input maxlength="250" class="form-control" placeholder="0x0000000000000000000000000000000000000000" [(ngModel)]="coin.contract" #coinContract="ngModel" name="coinContract" type="text" [ngClass]="{ 'is-invalid': submitted && coinContract.errors && coinContract.errors.required }" required>
          </div>
          <p *ngIf="coinContract.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinContract.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
        <div class="form-group">
          <label>Description*</label>
          <div class="inputBox">
            <textarea maxlength="2000" class="form-control" placeholder="Describe your coin here. What is the goal, plans, why is this coin unique?" [(ngModel)]="coin.description" #coinDescription="ngModel" name="coinDescription" type="text" [ngClass]="{ 'is-invalid': submitted && coinDescription.errors && coinDescription.errors.required }" required></textarea>
          </div>
          <p *ngIf="coinDescription.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinDescription.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
        <div class="form-group">
          <label>Launch Date*</label>
          <div class="inputBox">
            <input class="form-control" placeholder="Select date" readonly [owlDateTimeTrigger]="dt2" [owlDateTime]="dt2" [(ngModel)]="coin.launch" #coinLaunch="ngModel" name="coinLaunch" [ngClass]="{ 'is-invalid': submitted && coinLaunch.errors && coinLaunch.errors.required }" required>
          </div>
          <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
          <p *ngIf="coinLaunch.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinLaunch.errors.required">
              {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Website link*</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://www.coincatapult.com/" [(ngModel)]="coin.social.website" #coinWebsite="ngModel" name="coinWebsite" type="text" [ngClass]="{ 'is-invalid': submitted && coinWebsite.errors && coinWebsite.errors.required }" required>
          </div>
          <p *ngIf="coinWebsite.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinWebsite.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
<!--            <span *ngIf="coinWebsite.errors.pattern">-->
<!--               {{ 'invalidWebsite' | translate }}-->
<!--            </span>-->
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Telegram link*</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://t.me/coincatapult" [(ngModel)]="coin.social.telegram" #coinTelegram="ngModel" name="coinTelegram" type="text" [ngClass]="{ 'is-invalid': submitted && coinTelegram.errors && coinTelegram.errors.required }" required>
          </div>
          <p *ngIf="coinTelegram.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinTelegram.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
<!--            <span *ngIf="coinTelegram.errors.pattern">-->
<!--               {{ 'invalidWebsite' | translate }}-->
<!--            </span>-->
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Contact email</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="contact@coincatapult.com" [(ngModel)]="coin.social.email" #coinEmail="ngModel" name="coinEmail" type="text" [ngClass]="{ 'is-invalid': submitted && coinEmail.errors && coinEmail.errors.required }">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Twitter link</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://twitter.com/coincatapult" [(ngModel)]="coin.social.twitter" #coinTwitter="ngModel" name="coinTwitter" type="text" [ngClass]="{ 'is-invalid': submitted && coinTwitter.errors && coinTwitter.errors.required }">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Reddit link</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://www.reddit.com/" [(ngModel)]="coin.social.reddit" #coinReddit="ngModel" name="coinReddit" type="text" [ngClass]="{ 'is-invalid': submitted && coinReddit.errors && coinReddit.errors.required }">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Discord link</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://discord.gg/coincatapult" [(ngModel)]="coin.social.discord" #coinDiscord="ngModel" name="coinDiscord" type="text" [ngClass]="{ 'is-invalid': submitted && coinDiscord.errors && coinDiscord.errors.required }">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Facebook link</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://facebook.com/" [(ngModel)]="coin.social.facebook" #coinFacebook="ngModel" name="coinFacebook" type="text" [ngClass]="{ 'is-invalid': submitted && coinFacebook.errors && coinFacebook.errors.required }">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <label>Instagram link</label>
          <div class="inputBox">
            <input maxlength="200" class="form-control" placeholder="https://www.instagram.com/" [(ngModel)]="coin.social.instagram" #coinInstagram="ngModel" name="coinInstagram" type="text" [ngClass]="{ 'is-invalid': submitted && coinInstagram.errors && coinInstagram.errors.required }">
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="form-group">
          <label class="checkboxLabel" > I agree to the <a style="color: #ee9c00;" target="_blank" href="/terms-and-conditions">Terms and Conditions*</a>
            <input type="checkbox" [(ngModel)]="coin.terms" #coinTerms="ngModel" name="coinTerms" required>
            <span class="checkmark"></span>
          </label>
          <p *ngIf="coinTerms.errors && submitted" class="formError animate__animated ">
            <span *ngIf="coinTerms.errors.required">
               {{ 'fieldRequired' | translate }}
            </span>
          </p>
        </div>
      </div>
      <div class="col-lg-12 buttonLoading">
        <button (click)="save(form)" class="btn btn-primary-custom">
          <span *ngIf="!loading">
            Save
          </span>
          <div *ngIf="loading" class="buttonLoading">
            <div class="lds-ring page"><div></div><div></div><div></div><div></div></div>
          </div>
        </button>
      </div>
    </div>
  </form>
</div>
<app-upload-image (imageCroppedEvent)="getUploadedImage($event)"></app-upload-image>
<!--data-sitekey="6Lco6ysbAAAAAGG0gQ2iU7-rLExIom-V1btTfalA"-->
<!--data-callback='onSubmit'-->
<!--data-action='submit'-->
<!--<script>-->
<!--  function onSubmit(token) {-->
<!--    document.getElementById("addCoinForm").submit();-->
<!--  }-->
<!--</script>-->
